import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { GoLocation } from "react-icons/go";
import { MdUpdate } from "react-icons/md";
import { RiSignalWifi3Fill, RiSignalWifiOffLine } from "react-icons/ri";
import styled, { css, keyframes } from "styled-components";
import { RadioTower } from "lucide-react";
import { useHistory } from "react-router-dom";
import { GlobalState } from "../../GlobalState";
import Tooltip from "../utils/Tooltip";
import Loading from "../utils/loading";
import WaterSense from "../sensor_box/WaterSense";
import { literToKiloliter } from "../utils/utils";
// const Container = styled.div`
//   @media (min-width: 61.313em) {
//     display: flex;
//   }
// `;
const SensorWrapper = styled.div`
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 20px;  
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  padding: 0.5rem;

  border: 2px solid #fff;
  background-color: #fff;
  &:hover {
    border: 2px solid var(--primary);
  }
  width: 260px;
  margin: 0.3rem;
`;


const SensorValue = styled.h6`
  font-family: "montserrat-semi-bold";
  font-size: 1.2rem;
 
`;
const SensorUnit = styled.span`
  font-family: "montserrat-semi-bold";
  @media (min-width: 61.313em) {
    font-size: 1rem;
  }
`;

const SensorIconWrapper = styled.div`
  height: auto;
  margin: 0 auto;
  @media (min-width: 61.313em) {
    margin: 0.7rem auto;
  }
`;

const TimeElapsed = styled.p`
  font-size: 0.7rem;
  font-weight:bold;
  text-align: end;
  display: flex;
  align-items: center;
  @media (min-width: 61.313em) {
    text-align: end;
  }
`;
const LeftWrapper = styled.div`

display: flex;
flex-direction: column;
justify-content: space-between;
`

const RippleAnimation = keyframes`
  0% {box-shadow: 0 0 0px 0px #1AA3EC66;}
  100% {box-shadow: 0 0 0px 15px rgba(101, 255, 120, 0);}
`

const WaterSenseLight = styled.div`
width: 25px;
height: 12px;
border-radius:20%;
background-color: ${props => props.pumpState === 1 ? `#1AA3EC` : `#d9594c`};
  ${props => props.pumpState === 1 && css`
    {animation: ${RippleAnimation} 0.7s linear infinite;}`
  }
`

const SensorPercentage = styled.span`
  font-family: "montserrat-semi-bold";
  color: ${props => props.color};
  margin: 0 0.2rem;
`;

const LocationName = styled.h5`
  word-wrap: break-word;
  max-width: 90%;
`;
const WaterTankWrapper = styled.div`
  border: 1.5px solid #808080;
  border-radius: 5px;
  padding: 0.6rem 0.3rem;
  display: ${props => props.type?.includes("water-level") ? 'flex' : 'none'};
  width: 100px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.color};
  ${props => props.location === 'Terrace' && css`
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  `}

  ${props => props.value === 0 && css`
    display: none;
`}

`;


const AnimatedIconWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  position: relative;

  ${({ online }) =>
    online &&
    css`
      &::after {
        content: "";
        position: absolute;
        top: -4px; 
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: ${ripple} 1.5s infinite;
      }
    `}
`;

const AnimatedIcon = styled(RadioTower)`
  ${({ online }) =>
    online &&
    css`
      animation: ${pulse} 1.5s infinite;
      color: green;
    `}
`;

const pulse = keyframes`
  0% { opacity: 0.4; transform: scale(0.9); }
  50% { opacity: 1; transform: scale(1.1); }
  100% { opacity: 0.4; transform: scale(0.9); }
`;

const ripple = keyframes`
  0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
  100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
`;

const WaterFlowWrapper = styled.div`
display: flex;
align-items: flex-end;
`

export default function DashboadSensorBoxV3({ sensor_id, type }) {
  const state = useContext(GlobalState);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [waterLevel, setWaterLevel] = useState({
    value: 0,
    volume: 0,
    location_name: "Water Level",
    unit: "percent",
    color: "#1AA3EC",
    sensor_status: "online",
    date: "",
    time: "",
  });

  const sensorIds = Array.isArray(sensor_id) ? sensor_id : [sensor_id];

  useEffect(() => {
    async function fetchData(token, sensorIds) {
      try {
        const promises = sensorIds.map((id) =>
          axios.get(
            `${process.env.REACT_APP_API}/sensor/reading?sensor_id=${id}&type=${type}`,
            { headers: { Authorization: token[0] } }
          )
        );

        const results = await Promise.all(promises);
        const readings = results.map((res) => res.data);

        // Combine readings: sum or average water values
        const totalValue = readings.reduce((sum, r) => sum + parseFloat(r.value ?? 0), 0);
        const avgVolume = readings.reduce((sum, r) => sum + parseFloat(r.volume ?? 0), 0) / readings.length;

        // Determine overall sensor status (offline if any sensor is offline)
        const overallStatus = readings.some(r => r.sensor_status !== "online") ? "offline" : "online";

        setWaterLevel({
          ...readings[0], // base other info from first sensor
          value: totalValue,
          volume: avgVolume,
          sensor_status: overallStatus,
          location_name: "Water Level", // unified label
        });

        setLoading(false);
      } catch (err) {
        console.log(err.message);
      }
    }

    fetchData(state.token, sensorIds);
    const interval = setInterval(() => fetchData(state.token, sensorIds), 8000);

    return () => clearInterval(interval);
  }, [state.token, sensor_id, type]);

  if (loading) return <Loading />;

  return (
    <SensorWrapper onClick={() => history.push(`/sensor/${sensor_id}/${type}`)}>
      <LeftWrapper>
        <div style={{ display: "flex" }}>
          {/* {waterLevel.sensor_status === "online" ? (
            <RiSignalWifi3Fill size={20} color={"green"} />
          ) : (
            <Tooltip content="Sensor is offline." direction="right" delay="0">
              <RiSignalWifiOffLine size={20} color={"red"} />
            </Tooltip>
          )}{" "} */}


          <AnimatedIconWrapper online={waterLevel.sensor_status === "online"}>
            {waterLevel.sensor_status === "online" ? (
              <AnimatedIcon online size={22} strokeWidth={2} color="green" />
            ) : (
              <Tooltip content="Sensor is offline." direction="right" delay="0">
                <RadioTower size={22} strokeWidth={2} color="red" />
              </Tooltip>
            )}
          </AnimatedIconWrapper>


          &nbsp;<LocationName>{waterLevel.location_name}</LocationName>
        </div>
        <TimeElapsed>
          <MdUpdate /> &nbsp; {waterLevel.date} &bull; {waterLevel.time}
        </TimeElapsed>
      </LeftWrapper>

      <WaterTankWrapper
        type={waterLevel?.name}
        color={waterLevel?.volume_color}
        location={waterLevel?.location}
        value={parseFloat(waterLevel.value)}
      >
        {waterLevel.volume > 0 && (
          <SensorPercentage color={"#fff"}>
            {parseFloat(waterLevel.volume).toFixed(0)}%
          </SensorPercentage>
        )}

        <SensorValue style={{ color: "#fff" }}>
          <SensorUnit>
            {waterLevel.unit === "litre"
              ? literToKiloliter(waterLevel.value)
              : parseFloat(waterLevel.value).toLocaleString()}
          </SensorUnit>
        </SensorValue>
      </WaterTankWrapper>
    </SensorWrapper>
  );
}
